import { combineReducers } from 'redux';
import lfpGame from './onSite/lfpGame';
import matches from './onSite/matches';
import players from './onSite/players';
import suggestedQuotations from './onSite/suggestedQuotations/index.js';

export default combineReducers({
    lfpGame,
    matches,
    players,
    suggestedQuotations,
});



// WEBPACK FOOTER //
// ./src/reducers/app/onSite.js